import * as React from 'react';
import PutCallCard from 'components/SentimentCards/PutCallCard';
import CallPutMixCard from 'components/SentimentCards/CallPutMixCard';

interface SidebarItem {
  id: string;
  label: string;
  level?: number;
}

interface FlowAiAnalysisSidebarProps {
  activeTab?: string | null;
  onTabChange?: (tabId: string) => void;
  sections?: SidebarItem[];
  putContracts?: number;
  callContracts?: number;
  putPremium?: number;
  callPremium?: number;
  flowSideLabel?: string;
  bullishPremium?: number;
  bearishPremium?: number;
  neutralPremium?: number;
  showVisualizations?: boolean;
}

const FlowAiAnalysisSidebar: React.FC<FlowAiAnalysisSidebarProps> = ({
  activeTab,
  onTabChange,
  sections = [],
  putContracts = 0,
  callContracts = 0,
  putPremium = 0,
  callPremium = 0,
  bullishPremium = 0,
  bearishPremium = 0,
  neutralPremium = 0,
  showVisualizations,
}) => {
  if (sections.length === 0) {
    return null;
  }

  return (
    <div className="flex h-full w-56 flex-shrink-0 flex-col overflow-hidden border-r border-palette-border bg-palette-black-4">
      <nav className="min-h-0 flex-1 space-y-1 overflow-y-auto px-3 py-4">
        {sections.map((item) => {
          const isActive = activeTab === item.id;
          const isSubheading = item.level === 3;
          return (
            <button
              key={item.id}
              onClick={() => onTabChange?.(item.id)}
              aria-current={isActive ? 'location' : undefined}
              className={`w-full rounded-md border-l-2 px-3 py-2 text-left text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-blue ${
                isSubheading ? 'pl-6 text-xs' : ''
              } ${
                isActive
                  ? 'border-accent-blue bg-palette-black-3 text-white'
                  : 'border-transparent text-text-secondary hover:bg-palette-black-3 hover:text-white'
              }`}
            >
              {item.label}
            </button>
          );
        })}
      </nav>

      {/* Cards at the bottom */}
      {showVisualizations && (
        <div className="flex-shrink-0 space-y-2 px-3 pb-4">
          <PutCallCard
            bullishPremium={bullishPremium}
            bearishPremium={bearishPremium}
            neutralPremium={neutralPremium}
            variant="compact"
          />
          <CallPutMixCard
            callContracts={callContracts}
            putContracts={putContracts}
            callPremium={callPremium}
            putPremium={putPremium}
            variant="compact"
          />
        </div>
      )}
    </div>
  );
};

export default FlowAiAnalysisSidebar;
